import { render } from "./WhatChoiku.vue?vue&type=template&id=4d9a2def"
import script from "./WhatChoiku.vue?vue&type=script&lang=js"
export * from "./WhatChoiku.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./WhatChoiku.vue?vue&type=style&index=0&id=4d9a2def&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__